import colors from './colors';

export default {
  common: {
    white: colors.white,
    grey: colors.grey,
  },
  primary: {
    main: colors.spruce500,
    mainDisabled: colors.spruceDisabled,
    mainOpaque: colors.spruceOpaque,
  },
  secondary: {
    main: colors.jade200,
    lightMain: colors.spruce50,
  },
  error: {
    main: colors.pink200,
    light: colors.pink50,
    contrastMain: colors.pink800,
  },
  success: {
    main: colors.jade500,
    light: colors.spruce400,
    contrastMain: colors.white,
  },
  info: {
    main: colors.amber50,
    light: colors.amber50,
    divider: colors.neutral400,
  },
  background: {
    default: colors.white,
    textInput: colors.lightGrey,
    header: colors.spruce500,
    separator: colors.copper,
    contrastShadow: colors.whiteShadow,
    divider: colors.spruce300,
    lightDivider: colors.spruce10,
    neutral: colors.neutral50,
    tag: colors.amber50,
    tagBorder: colors.amber200,
    calories: colors.spruce50,
    total: colors.spruce100,
    progress: colors.sunshine100,
    splitItems: colors.spruce600,
    billTotalContainer: colors.spruce50,
    textInputTitle: colors.spruce200,
    shadow: colors.shadow,
    container: colors.skyGrey,
    lightButton: colors.neutral,
    imageOverlay: colors.spruce500,
  },
  action: {
    disabled: colors.spruceDisabled,
    selected: colors.spruce600,
    activeOption: colors.greyActive,
    deselected: colors.greenDeselected,
    active: colors.jade500,
    contrast: colors.neutral200,
    inactive: colors.spruce50,
  },
  text: {
    primary: colors.spruce700,
    secondary: colors.neutral500,
    selected: colors.jade200,
    contrastText: colors.white,
    logo: colors.neutral50,
    logoText: colors.red,
    bannerText: colors.cactus,
    iconText: colors.iconYellowDark,
    tableColumn: colors.greyMedium,
    editControls: colors.pink600,
    header: colors.white,
  },
  icon: {
    heart: colors.pink200,
  },
};
